import React from 'react';
import './styles/global.css';

// Hooks
import { useTheme } from './hooks/useTheme';

// Layout
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';

// Sections
import { Hero }       from './components/sections/Hero';
import { About }      from './components/sections/About';
import { Skills }     from './components/sections/Skills';
import { Experience } from './components/sections/Experience';
import { Projects }   from './components/sections/Projects';
import { Contact }    from './components/sections/Contact';

/**
 * Root application component.
 * Owns the dark/light theme state and passes it down to Navbar.
 * All sections are composed here in document order.
 */
const App: React.FC = () => {
  const { dark, toggle } = useTheme();

  return (
    <>
      <Navbar dark={dark} onToggleTheme={toggle} />

      <main>
        <Hero />

        <hr className="sec-divider" />
        <About />

        <hr className="sec-divider" />
        <Skills />

        <hr className="sec-divider" />
        <Experience />

        <hr className="sec-divider" />
        <Projects />

        <hr className="sec-divider" />
        <Contact />
      </main>

      <Footer />
    </>
  );
};

export default App;
